// Volume-rendering intent handlers.

import { INTENTS } from '@store/intents';
import { params } from '@store/instance';
import { syncVolume, teardownVolume } from '@scene/volume';
import type { Store } from '@store/store';
import type { State } from '@store/schema';
import type { ViewerContext } from '../context';

export function register(store: Store<State>, viewer: ViewerContext): Array<() => void> {
    const offs: Array<() => void> = [];

    offs.push(store.onIntent(INTENTS.TOGGLE_VOLUME, (p) => {
        const next = (p && typeof p.enabled === 'boolean') ? p.enabled : !params.volumeEnabled;
        params.volumeEnabled = next;
        if (next) syncVolume(viewer, params);
        else teardownVolume(viewer);
        store.dispatch(INTENTS.UI_PANE_REFRESH);
    }));

    return offs;
}
